export function stringToDate(stringToConvert?: DateString | Date | null) {
  return (typeof stringToConvert === "string") ? new Date(stringToConvert) : stringToConvert;
}

export function now() {
  return new Date();
}

export function yesterday() {
  return now().setDate(now().getDate() - 1);
}

export function atEarliestNow(date: Date) {
  return date < now() ? now() : date;
}

export function translateToEffectiveDateReverse(date: DateString | Date) {
  const returnDate = stringToDate(date);

  if (returnDate instanceof Date) {
    return returnDate < now() ? new Date(0) : returnDate;
  } else {
    return !!returnDate;
  }
}

export function translateToEffectiveDate(date: DateString | Date) {
  const returnDate = stringToDate(date);

  if (returnDate instanceof Date) {
    return returnDate < now() ? false : returnDate;
  } else {
    return !!returnDate;
  }
}

export function areEqualEffectiveDates(dateA: DateString | Date, dateB: DateString | Date) {
  return dateA === dateB || (dateA instanceof Date && dateB instanceof Date && dateA.getTime() === dateB.getTime());
}

const TRUNCATE_COUNT = 8;
export function selectionDescription(selected: Array<{id: number}>) {
  if (selected.length === 0) {
    return "";
  } else {
    const selectedIDs = selected.map((item) => item.id);
    if (selected.length > (TRUNCATE_COUNT + 1)) {
      return ` (${selectedIDs.slice(0, TRUNCATE_COUNT).join(", ")}, and ${selected.length - TRUNCATE_COUNT} more)`;
    } else {
      return ` (${selectedIDs.join(", ")})`;
    }
  }
}

export function hideUntilShouldHideNow(hideUntil: Date | DateString | boolean) {
  const parseHideUntil = (typeof hideUntil === "string") ? new Date(hideUntil) : hideUntil;
  return (parseHideUntil instanceof Date) ? new Date() < parseHideUntil : parseHideUntil;
}
